import React from 'react';
import { MapPin } from 'lucide-react';
import { COMPANY_INFO } from '../mock';

export const GeoSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-[400px] h-[400px] bg-brand-green/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-brand-green/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/15 text-brand-green-light rounded-full text-sm font-semibold mb-6 border border-brand-green/25">
            Unsere Reichweite
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 tracking-tight">
            Bundesweit vor Ort
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-normal">
            Deutschlandweit im Einsatz – wir kommen zu Ihnen
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-10 lg:p-16 shadow-2xl">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {[
              { city: "Hamburg", region: "Norddeutschland" },
              { city: "Schleswig-Holstein", region: "Norddeutschland" },
              { city: "Niedersachsen", region: "Norddeutschland" },
              { city: "Nordrhein-Westfalen", region: "Westdeutschland" },
              { city: "Bayern", region: "Süddeutschland" },
              { city: "Berlin", region: "Ostdeutschland" }
            ].map((location, index) => (
              <div key={index} className="flex items-center gap-4 p-5 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 hover:border-brand-green/30 transition-all">
                <div className="w-12 h-12 bg-brand-green/15 rounded-xl flex items-center justify-center flex-shrink-0 border border-brand-green/25">
                  <MapPin className="w-6 h-6 text-brand-green" />
                </div>
                <div>
                  <p className="font-semibold text-white text-lg">{location.city}</p>
                  <p className="text-sm text-gray-400">{location.region}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center pt-10 border-t border-white/10">
            <p className="text-gray-400 mb-6 text-lg">
              Ihr Standort nicht dabei? Kein Problem – wir kommen trotzdem zu Ihnen.
            </p>
            <a href={`tel:${COMPANY_INFO.phone}`}>
              <p className="text-2xl font-bold text-brand-green hover:text-brand-green-light transition-colors cursor-pointer">
                Jetzt anrufen
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};